export default function TermsOfService() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900 px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 mt-5">Terms of Service</h1>

        <p className="text-slate-600 leading-relaxed mb-6">
          These Terms of Service govern your access to and use of LeadOnLeads. By using our website and services, you agree to these terms.
        </p>

        <section className="space-y-6 text-slate-700">
          <div>
            <h2 className="text-xl font-semibold mb-2">Use of Service</h2>
            <p className="mb-2">
              You may use LeadOnLeads only for lawful purposes and in compliance with these Terms. You must not misuse the service, interfere with operations, or attempt unauthorized access.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Account Responsibilities</h2>
            <p className="mb-2">
              If you create an account, you are responsible for maintaining the confidentiality of your credentials and for all activity under your account.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
            <p className="mb-2">
              All content, branding, and software on LeadOnLeads are the property of LeadOnLeads or its licensors. You may not reproduce or distribute content without permission.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Disclaimer</h2>
            <p className="mb-2">
              The service is provided “as is” without warranties of any kind. We do not guarantee that the service will be uninterrupted, error-free, or secure.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Limitation of Liability</h2>
            <p className="mb-2">
              To the fullest extent permitted by law, LeadOnLeads will not be liable for indirect, incidental, consequential, or punitive damages arising from your use of the service.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
            <p className="mb-2">
              These Terms are governed by the laws of the applicable jurisdiction. Any disputes will be subject to the courts of that jurisdiction.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Contact</h2>
            <p className="mb-2">
              For questions about these Terms, contact us at contact@leadonleads.com.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
